import {useTranslation} from "react-i18next"; // Import the translation hook for multi-language support
import {useEffect, useState} from "react";
import {toast} from "react-toastify"; // Import React hooks

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AddRemoveItemsApp = ({ show }) => {
    const { t } = useTranslation(); // Initialize the translation function
    const [remove, setRemove] = useState(''); // State to store search query
    const [totalItems, setTotalItems] = useState([]); // State to store the list of total selected items
    const [steps, setSteps] = useState([t("add"), t("remove")]); // State for step titles in the event creation process
    const [activeStep, setActiveStep] = useState(0); // State to track active step in the process
    const [emptyFields, setEmptyFields] = useState(false);
    const [selectedAssignTo, setSelectedAssignTo] = useState(null);

    // Reset add state when props.show is false
    useEffect(() => {
        if (show === false) {
            setSelectedAssignTo(null);
            setTotalItems([])
        }
    }, [show]);

    // Function to handle the removal of a selected item
    const handleRemoveSelected = (element) => {
        setTotalItems(totalItems.filter((item) => item?.id !== element.id)); // Remove item from totalItems state
    };

    // Function to handle selecting an item from the list
    const handleSelected = (element) => {
        const selectedElement = totalItems?.find((item) => item?.id === element?.id);
        if (selectedElement) {
            toast.warn(`${selectedElement?.label} ${t('is_already_selected')}`); // Show warning if item is already selected
        } else {
            setTotalItems([...totalItems, element]); // Add item to the selected items list
        }
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
        setSelectedAssignTo(null);
    }

    // Return the necessary variables and functions for use in other parts of the app
    return {
        t, // Translation function
        steps,
        activeStep,
        setActiveStep,
        remove,
        setRemove,
        totalItems,
        emptyFields,
        setEmptyFields,
        selectedAssignTo,
        setSelectedAssignTo,
        handleRemoveSelected,
        handleStepChange,
        handleSelected
    };
}

export default AddRemoveItemsApp; // Export the component to be used in other parts of the app
